import React from 'react'
import { Link } from 'gatsby'
import { Button } from 'theme-ui'
//import Section from '@components/Section'
import { Heading, Box } from 'theme-ui'

/**
 * Shadow me to add your own content
 */

const styles = {
  wrapper: {
    ml: 3
  },
  heading: {
    color: `alpha`
  },
  running: {
    color: `omegaDark`,
    fontWeight: `body`
  }
}

export default () => (
  <Box sx={styles.wrapper}>
    <Heading variant='h1' sx={styles.heading}>
      Swift in an Arm Cloud.
    </Heading>
    <Heading variant='h2' sx={styles.running}>
      "How to install Swift on an AWS arm cloud server in only a few minutes."
    </Heading>
    <Button variant='primary' as={Link} to='/install-swift-on-an-aws-cloud-server'>
      Read More...
    </Button>
  </Box>
)
